import React, { useState, useEffect } from 'react';

const MonitorSummary = () => {
  const [totalAmount, setTotalAmount] = useState(0);
  const [slipCount, setSlipCount] = useState(0);
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    // Retrieve saved data from localStorage
    const savedAmount = parseFloat(localStorage.getItem('totalAmount')) || 0;
    const savedCount = parseInt(localStorage.getItem('slipCount')) || 0;
    const lastReset = localStorage.getItem('lastReset');
    const today = new Date().toDateString();

    // Reset values if the date has changed
    if (lastReset !== today) {
      localStorage.setItem('totalAmount', 0);
      localStorage.setItem('slipCount', 0);
      localStorage.setItem('lastReset', today);
      setTotalAmount(0);
      setSlipCount(0);
    } else {
      setTotalAmount(savedAmount);
      setSlipCount(savedCount);
    }

    // Update time every second
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer); // Cleanup on unmount
  }, []);

  return (
    <div style={{
      width: '400px',
      padding: '20px',
      border: '2px solid #ccc',
      textAlign: 'center',
      backgroundColor: '#f9f9f9',
      borderRadius: '10px',
      boxShadow: '2px 2px 10px rgba(0,0,0,0.1)',
      margin: '50px auto',
    }}>
      <h2>Monitor Summary</h2>
      <p><strong>Local Time:</strong> {currentTime.toLocaleTimeString()}</p>
      <p><strong>Total Amount:</strong> ฿{Number(totalAmount).toFixed(2)}</p>
      <p><strong>Slips Uploaded:</strong> {slipCount}</p>
    </div>
  );
};

export default MonitorSummary;
